import { ApiRequest, RequestMethod } from "../../request";

export async function addUpgrade(
  fighterId: string,
  fighterWeaponId: string,
  upgradeId: string,
  purchaseWithCredits: boolean
): Promise<boolean> {
  const URL = `/api/fighter/${fighterId}/fighter-weapon/add-upgrade`;
  const apiRequest = new ApiRequest();

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    fighterWeaponId: fighterWeaponId,
    upgradeId: upgradeId,
    purchaseWithCredits: purchaseWithCredits,
  });

  const response: any = await apiRequest.send();

  return response.status === 200;
}
